<template>
  <div class="favorite-form">
    <button
      :class="favoriteButtonClass"
      @click="changeFavorite"
    ></button>
  </div>
</template>

<script>
export default {
  name: 'FavoriteComponent',
  props: {
    id: {
      type: Number,
      default: 0,
    },
    favoriteAdded: {
      type: Boolean,
      defalut: false,
    },
    pageType: {
      type: String,
      defalut: 'course',
    },
  },
  data() {
    return {
        favoriteAddedData: this.favoriteAdded,
    };
  },
  computed: {
    favoriteButtonClass() {
      return {
        'btn collet-button': true,
        'bar-favorite-btn': true,
        added: this.favoriteAddedData,
      };
    },
  },
  created() {
    this.$emit('change-favorite-added-data', this.favoriteAdded);
  },
  methods: {
    // eslint-disable-next-line consistent-return
    async changeFavorite() {
      // 改為相反的狀態
      // this.favoriteAddedData = ! this.favoriteAddedData;
      let response;
      try {
        response = await axios.post(`${this.pageType}/favorite/${this.id}`);
      } catch (error) {
        console.warn(error);
      }

      const { data } = response;

      if (data.status === 'not login') {
        window.location.href = 'user/login';

        global.Message.show('請先登入會員');

        return false;
      }

      if (data.favoriteAdded) {
        global.Message.show('已經加入喜愛');
      } else {
        global.Message.show('已經從喜愛中移除');
      }
        this.favoriteAddedData = data.favoriteAdded;
      this.$emit('change-favorite-added-data', data.favoriteAdded);
    },
  },
};
</script>
<style scoped lang="scss">
.favorite-form {
  display: flex;
  margin-left: 1rem;
  height: 25px;

  button {
    width: 25px;
    height: 25px;
    margin: 0 1rem;
    transition: 0.3s;
    background: url(../img/pic/love.svg) no-repeat;
    background-size: contain;
      &:hover,
      &.added {
        background: url(../img/pic/love_green.svg) no-repeat;
      }
  }
}

</style>
